/* eslint-disable no-restricted-syntax */
import { Component, PropsWithChildren } from 'react'
import { log } from 'utils/logging'
import { Criticality, Severity } from 'types/logging'
import { MapErrorBoundaryState } from './types'

// A partially loaded Maps SDK makes every marker throw on mount, which would otherwise take down the whole page via
// the app-wide ErrorBoundary; the page stays usable without the map
class MapErrorBoundary extends Component<PropsWithChildren, MapErrorBoundaryState> {
  private hasLogged = false

  constructor(props: PropsWithChildren) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): MapErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error) {
    if (this.hasLogged) return
    this.hasLogged = true

    log({
      error,
      identifier: '[ProducerMap:ErrorBoundary]',
      severity: Severity.WARNING,
      criticality: Criticality.LOW
    })
  }

  render() {
    return this.state.hasError ? null : this.props.children
  }
}

export default MapErrorBoundary
